import moment from 'moment'
import { minLength, maxLength, required, minValue, numeric } from 'vuelidate/lib/validators'
import { notOnlySpace, isFuture, isLesserOrEqualThanField, isGreaterOrEqualThanField } from '@/helpers/validators.js'

export const getRaffleValidations = (raffle, isDraft) => {
  let validations = {
    raffle: {
      title: {
        required,
        minLength: minLength(2),
        maxLength: maxLength(70),
        notOnlySpace,
      },
      description: {},
      start_date: {},
      units: {},
      app_description: {},
      rules: {
        products: {},
      },
      prizes: {},
      app_start_exhibition_date: {},
      register_number: {},
      max_numbers_per_person: {},
      max_numbers_per_coupon: {},
      banner_url: {},
      rules_url: {},
      ...(raffle?.optin?.active && {
        optin: {
          terms: {
            required,
            notOnlySpace,
            maxLength: maxLength(10000),
          },
        },
      }),
      ...(raffle.lucky_number_generation_type === 'SECAP' && { register_number: required, min_series: required, max_series: required }),
    },
  }
  if (isDraft && !(raffle.status === 'ONGOING' || raffle.status === 'SCHEDULED')) {
    return validations
  } else if (!isDraft && (raffle.status === 'ONGOING' || raffle.status === 'SCHEDULED' || raffle.status === 'FINISHED')) {
    validations.raffle.description = {
      minLength: minLength(2),
      maxLength: maxLength(150),
      notOnlySpace,
    }
    validations.raffle.rules = {
      value: {
        required,
        minValue: () => {
          const rulesValue = raffle.rules.value
          const minValue = raffle.rules.type === 'BY_SELECTED_ITEMS_QUANTITY' ? 1 : 0.01
          if (typeof rulesValue === 'string') {
            return parseFloat(rulesValue?.replace(',', '.')) >= minValue
          }
          return rulesValue >= minValue
        },
      },
      products: {},
    }
    validations.raffle.prizes = {
      required,
      minLength: function () {
        return raffle.prizes.length >= 1
      },
      moreThanFiveDaysFromStartDate: function () {
        let validationResult = true
        raffle.prizes.map((prize) => {
          if (moment(prize.raffle_date).diff(moment(raffle.start_date), 'days') < 5) {
            validationResult = false
          }
        })
        return validationResult
      },
    }
    validations.raffle.app_start_exhibition_date = {
      lessOrEqualStartDate: () => {
        if (!raffle.app_start_exhibition_date || !raffle.start_date) {
          return true
        }
        return moment(raffle.app_start_exhibition_date) <= moment(raffle.start_date)
      },
    }
    validations.raffle.app_description = {
      required,
      minLength: minLength(7),
      maxLength: maxLength(1000),
      notOnlySpace,
    }
    if (raffle.lucky_number_generation_type === 'SECAP') {
      validations.raffle.register_number = { required }
      validations.raffle.min_series = {
        required,
        numeric,
        lesserOrEqualThanMax: isLesserOrEqualThanField('max_series'),
      }
      validations.raffle.max_series = {
        required,
        numeric,
        greaterOrEqualThanMin: isGreaterOrEqualThanField('min_series'),
      }
    }
    validations.raffle.max_numbers_per_person = {
      minValue: minValue(1),
    }
    validations.raffle.max_numbers_per_coupon = {
      minValue: minValue(1),
    }
    validations.raffle.units = {
      required,
      minLength: minLength(1),
    }
    return validations
  }
  validations = {
    raffle: {
      title: {
        required,
        minLength: minLength(2),
        maxLength: maxLength(70),
        notOnlySpace,
      },
      description: {
        minLength: minLength(2),
        maxLength: maxLength(150),
        notOnlySpace,
      },
      start_date: {
        required,
        isFuture,
      },
      units: {
        required,
        minLength: minLength(1),
      },
      app_description: {
        required,
        minLength: minLength(7),
        maxLength: maxLength(1000),
        notOnlySpace,
      },
      rules: {
        value: {
          required,
          minValue: () => {
            const rulesValue = raffle.rules.value
            const minValue = raffle.rules.type === 'BY_SELECTED_ITEMS_QUANTITY' ? 1 : 0.01
            if (typeof rulesValue === 'string') {
              return parseFloat(rulesValue?.replace(',', '.')) >= minValue
            }
            return rulesValue >= minValue
          },
        },
        products: {},
      },
      prizes: {
        required,
        minLength: function () {
          return raffle.prizes.length >= 1
        },
        moreThanFiveDaysFromStartDate: function () {
          let validationResult = true
          raffle.prizes.map((prize) => {
            if (moment(prize.raffle_date).diff(moment(raffle.start_date), 'days') < 5) {
              validationResult = false
            }
          })
          return validationResult
        },
      },
      app_start_exhibition_date: {
        lessOrEqualStartDate: () => {
          if (!raffle.app_start_exhibition_date || !raffle.start_date) {
            return true
          }
          return moment(raffle.app_start_exhibition_date) <= moment(raffle.start_date)
        },
      },
      register_number: {
        minValue: minValue(0),
      },
      max_numbers_per_person: {
        minValue: minValue(1),
      },
      max_numbers_per_coupon: {
        minValue: minValue(1),
      },
      banner_url: {
        required,
      },
      rules_url: {
        required,
      },
      ...(raffle?.optin?.active && {
        optin: {
          terms: {
            required,
            notOnlySpace,
            maxLength: maxLength(10000),
          },
        },
      }),
      ...(raffle.lucky_number_generation_type === 'SECAP' && {
        register_number: { required },
        min_series: {
          required,
          numeric,
          lesserOrEqualThanMax: isLesserOrEqualThanField('max_series'),
        },
        max_series: {
          required,
          numeric,
          greaterOrEqualThanMin: isGreaterOrEqualThanField('min_series'),
        },
      }),
    },
  }
  if (
    [
      'BY_SELECTED_ITEMS_QUANTITY',
      'BY_SELECTED_ITEMS_VALUE',
      'BY_COUPON_TOTAL_VALUE_PARTICIPANT_PRODUCT',
      'BY_COUPON_TOTAL_VALUE_ACCELERATOR_PRODUCT',
    ].includes(raffle.rules.type)
  ) {
    validations.raffle.rules.products = {
      required,
      minLength: minLength(1),
    }
  }
  if (raffle.rules.type === 'BY_COUPON_TOTAL_VALUE_ACCELERATOR_PRODUCT') {
    validations.raffle.rules.acceleration_operation = {
      required,
    }
    validations.raffle.rules.acceleration_value = {
      required,
      minValue: minValue(1),
    }
  }
  if (raffle.rules.type === 'BY_COUPON_TOTAL_VALUE_ACCELERATOR_PRODUCT_GROUPS_WITH_CUMULATIVE') {
    validations.raffle.rules.product_groups = {
      required,
      minLength: minLength(1),
    }
  }
  return validations
}
